module.exports = __webpack_public_path__ + "static/img/fanBanner.e5a1dce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fan/fanBanner.png
// module id = Jl1i
// module chunks = 1